import React, { Component } from "react";
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { MAX_LENGTH, ARTICLE_FORMULA_LABELS, MODAL_CUSTOM_MESSAGE } from "../../../../../../../constants/external-constants";
import { CONFIRMATION_VALUE, TRANSLATIONS as translation } from "../../../../../../../utils/constant.utils";
import { OR_RRF_TextArea as TextArea } from "../../../../../../common/forms/order-request-form.component";
import { Button } from "react-bootstrap";
import { NotificationModal } from "../../../../../../common/modal/notification-modal.component";
import { articleCatalogueMilestoneActions } from "../../../../../../../store/external/recharge-reducer/article-catalogue-milestone.reducer/article-catalogue-milestone.reducer";
import { safeEval } from "../../../../../../../utils/helpers.utils";
import { ConfirmationNotificationModal } from "../../../../../../common/modal/confirmation-modal.component";
class Formula extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showNotif: false,
            haveError: false,
            modalMessage: '',
            formula: '',
            formulaValidatedSuccess: false,
            showModal: false,
        };
    }

    componentDidMount() {
        this.props.updateDisabledButton(true, false);
        this.setState((prevState) => {
            this.setState({ formulaValidatedSuccess: false, })
        })
    }

    componentDidUpdate(prevProps, prevState) {
        const { formulaValidatedSuccess } = this.state;
        if (prevState.formulaValidatedSuccess !== formulaValidatedSuccess) {
            if (formulaValidatedSuccess) {
                this.props.updateDisabledButton(false, false);
            }
            else {
                this.props.updateDisabledButton(true, false);
            }
        }
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props.translation;
        if (locale === null || locale === '' || locale === undefined)
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    };

    handleCloseNotif = () => {
        this.setState({ showNotif: false });
    };

    handleInputChange = (e) => {
        this.props.FormChange("articleCatalogueMilestoneForm.formula", e.target.value);
        this.setState({ formula: e.target.value, haveError: false, formulaValidatedSuccess: false }); // Reset error when user types
    };

    handleCancel = () => {
        this.setState({
            showModal: true,
            haveError: true,
        });

    };

    handleConfirmationModal = async (buttonType) => {
        this.setState(prev => ({
            showModal: !prev.showModal,
        }));

        if (buttonType === CONFIRMATION_VALUE.Ok) {
            this.handleResetField();
            this.setState({
                formulaValidatedSuccess: false,
            });
        }
        else {
            this.setState({
                showModal: false
            })
        }
    };

    handleResetField = () => {
        this.props.FormChange("articleCatalogueMilestoneForm.formula", null);
        this.setState({ formula: '', haveError: false });
    };

    handleValidation = () => {
        const { componentsMilestone } = this.props;
        const { formula } = this.props.articleCatalogueMilestoneForm;

        // Regular expressions
        const validComponentRegex = /\[[^\]]+\]/g; // Matches valid components enclosed in brackets
        const spaceCharacterRegex = /\s/; // Detects spaces
        const consecutiveOperatorsRegex = /[\+\-\*/]{2,}/; // Detects consecutive operators like ++, --, **, //
        const parenthesisMatchRegex = /\(|\)/g; // Matches parentheses
        const nonBracketedWordsRegex = /(?<![\[\]])\b[a-zA-Z_][a-zA-Z0-9_]*\b(?![\[\]])/g; // Detects unbracketed words
        const specialCharacterRegex = /[^a-zA-Z0-9+\-*/()[\]_.\s]/; // Detects special characters NOT allowed
        const invalidOperatorPlacementRegex = /[\+\-\*/]\)/; // Detects invalid placement like `[Comp1] + ([Comp2]-)`
        const invalidDecimalRegex = /(^|[^\d])\.\d*\.|\.\D|^\./; // Detects multiple decimals in a number
        const divisionByZeroRegex = /\/\s*0(\.0+)?\b(?!\.\d+)/; // Detects division by zero (e.g., `1/0`, `5/0.0`)
        const consecutiveComponentsRegex = /\]\s*\[/g; // Detects `[TESTCOMP123][TESTCOMP12]` without an operator

        // Trim formula for empty check
        const trimmedFormula = formula.trim();

        // 1. Check if formula is empty
        if (!trimmedFormula) {
            this.setState({
                showNotif: true,
                haveError: true,
                formulaValidatedSuccess: false,
                modalMessage: "formula_empty_error",
            });
            return ["formula"];
        }

        // 2. Check for special characters
        if (specialCharacterRegex.test(formula)) {
            this.setState({
                showNotif: true,
                haveError: true,
                formulaValidatedSuccess: false,
                modalMessage: "component_special_character",
            });
            return ["formula"];
        }

        // 3. Check for invalid decimal usage
        if (invalidDecimalRegex.test(formula)) {
            this.setState({
                showNotif: true,
                haveError: true,
                formulaValidatedSuccess: false,
                modalMessage: "formula_syntax_error",
            });
            return ["formula"];
        }

        // 4. Check for division by zero
        if (divisionByZeroRegex.test(formula)) {
            this.setState({
                showNotif: true,
                haveError: true,
                formulaValidatedSuccess: false,
                modalMessage: "formula_syntax_error",
            });
            return ["formula"];
        }
        // Extract bracketed components
        const matchedComponents = formula.match(validComponentRegex) || [];
        let componentNames = matchedComponents.map(comp => comp.replace(/\[|\]/g, "")); // Extract component names

        // Convert milestone and component names to uppercase for case-insensitive check
        const rateComponentList = componentsMilestone.map(comp => comp.RateComponent.toUpperCase());
        const invalidComponents = componentNames.filter(comp => !rateComponentList.includes(comp.toUpperCase()));

        // 5. Check if all components are enclosed in brackets
        const cleanedFormula = formula.replace(validComponentRegex, "").trim();
        const nonBracketedMatches = cleanedFormula.match(nonBracketedWordsRegex);
        if (nonBracketedMatches) {
            this.setState({
                showNotif: true,
                haveError: true,
                formulaValidatedSuccess: false,
                modalMessage: "formula_bracket_error",
            });
            return ["formula"];
        }

        // 6. Check if components exist in Components Milestone
        if (invalidComponents.length > 0) {
            this.setState({
                showNotif: true,
                haveError: true,
                formulaValidatedSuccess: false,
                modalMessage: "formula_component_dne_error",
            });
            return ["formula"];
        }

        // 7. Check if restricted components are present
        const errorMapping = {
            country_vat: "formula_countryvat_error",
            hw_fee: "formula_hwfee_error"
        };

        const foundComponent = Object.keys(errorMapping).find(comp =>
            componentNames.some(name => name.toLowerCase() === comp)
        );

        if (foundComponent) {
            this.setState({
                showNotif: true,
                haveError: true,
                formulaValidatedSuccess: false,
                modalMessage: errorMapping[foundComponent],
            });
            return ["formula"];
        }

        // 8. Check for spaces in the formula
        if (spaceCharacterRegex.test(formula)) {
            this.setState({
                showNotif: true,
                haveError: true,
                formulaValidatedSuccess: false,
                modalMessage: "component_space_character_error",
            });
            return ["formula"];
        }

        // 9. Check if components exceed 20
        if (componentNames.length > 20) {
            this.setState({
                showNotif: true,
                haveError: true,
                formulaValidatedSuccess: false,
                modalMessage: "formula_component_limit_error",
            });
            return ["formula"];
        }

        // 10. Syntax Validations for Mathematical Expressions
        const formulaWithoutComponents = formula.replace(validComponentRegex, "[X]"); // Replace components with [X] for easier math validation

        // 10.1 Operators at the beginning or end
        if (/^[+\-*/]|[+\-*/]$/.test(formulaWithoutComponents)) {
            this.setState({
                showNotif: true,
                haveError: true,
                formulaValidatedSuccess: false,
                modalMessage: "formula_syntax_error",
            });
            return ["formula"];
        }

        // 10.2 Consecutive operators (e.g., ++, **, //, --)
        if (consecutiveOperatorsRegex.test(formulaWithoutComponents)) {
            this.setState({
                showNotif: true,
                haveError: true,
                formulaValidatedSuccess: false,
                modalMessage: "formula_syntax_error",
            });
            return ["formula"];
        }

        // 10.3 Mismatched parentheses count
        const parenthesisMatch = formulaWithoutComponents.match(parenthesisMatchRegex);
        if (parenthesisMatch) {
            const openCount = parenthesisMatch.filter(p => p === "(").length;
            const closeCount = parenthesisMatch.filter(p => p === ")").length;
            if (openCount !== closeCount) {
                this.setState({
                    showNotif: true,
                    haveError: true,
                    formulaValidatedSuccess: false,
                    modalMessage: "formula_syntax_error",
                });
                return ["formula"];
            }
        }

        // 10.4 Invalid operator placement (e.g., `[Comp1] + ([Comp2]-)` or `1+2-)`)
        if (invalidOperatorPlacementRegex.test(formulaWithoutComponents)) {
            this.setState({
                showNotif: true,
                haveError: true,
                formulaValidatedSuccess: false,
                modalMessage: "formula_syntax_error",
            });
            return ["formula"];
        }

        // 10.5 Check for consecutive bracketed components without an operator
        if (consecutiveComponentsRegex.test(formula)) {
            this.setState({
                showNotif: true,
                haveError: true,
                formulaValidatedSuccess: false,
                modalMessage: "formula_syntax_error",
            });
            return ["formula"];
        }

        // 10.6 Check for operations resulting in infinite values 
        try {
            let evalFormula = formula;
            componentsMilestone.forEach(({ RateComponent, Amount, Percent }) => {
                const value = (Amount !== null && Amount !== '') ? Amount : (Percent !== null && Percent !== '') ? Percent : 0;
                const regex = new RegExp(`\\[${RateComponent}\\]`, "gi");
                evalFormula = evalFormula.replace(regex, value);
            });

            const evalResult = safeEval(evalFormula);
            // Limit result to 1e30
            if (!isFinite(evalResult) || Math.abs(evalResult) > 1e30) {
                this.setState({
                    showNotif: true,
                    haveError: true,
                    formulaValidatedSuccess: false,
                    modalMessage: "formula_syntax_error",
                });
                return ["formula"];
            }
        } catch (error) {
            this.setState({
                showNotif: true,
                haveError: true,
                formulaValidatedSuccess: false,
                modalMessage: "formula_syntax_error",
            });
            return ["formula"];
        }
        // Convert all component names to uppercase in the final validated formula
        let finalFormula = formula;
        componentNames.forEach(comp => {
            const regex = new RegExp(`\\[${comp}\\]`, "gi"); // Case-insensitive replacement
            finalFormula = finalFormula.replace(regex, `[${comp.toUpperCase()}]`);
        });

        // All Checks Passed - Formula is Valid
        this.setState({
            showNotif: true,
            haveError: false,
            formulaValidatedSuccess: true,
            modalMessage: "formula_validated_success",
            formula: finalFormula, // Update formula with uppercase components
        });
        this.props.FormChange("articleCatalogueMilestoneForm.formula", finalFormula);
    };


    render() {
        return (
            <div className="formula__container">
                <div className="flex-row align-items-center">
                    <div className="flex-grow-1">
                        <TextArea
                            label={`${this.toLocaleLanguage('client_formula')}`}
                            fieldProp='props'
                            value={this.props.articleCatalogueMilestoneForm.formula}
                            onChange={this.handleInputChange}  // Ensure input updates state
                            placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                            name="formula"
                            customClass={this.state.haveError ? "border-red" : ""} // Apply error style
                            disabled={this.props.isViewing}
                        />
                    </div>
                    {
                        this.props.isViewing || this.props.isReadAndWrite ? (
                            <>
                    <span className="fw-semibold">
                        {ARTICLE_FORMULA_LABELS.ConstantFormula}
                    </span>
                    <div className={'btn-tooltiptext'}>
                        <div className="btn-tooltiptext">
                            <Button 
                                variant="outline-secondary" 
                                className="btn-custom-violet-hover-outline" 
                                onClick={this.handleCancel}
                                disabled={this.props.isViewing ?? false}>
                                 {this.toLocaleLanguage("clear_formula")}
                            </Button>
                            <span className="tooltip-text">{this.toLocaleLanguage("clear_formula")}</span>
                        </div>
                        <span className="tooltip-text">{this.toLocaleLanguage("clear_formula")}</span>
                    </div>
                    <div className={'btn-tooltiptext'}>
                        <div className="btn-tooltiptext">
                            <Button
                                variant="outline-secondary"
                                className="btn-custom-violet-hover-outline"
                                onClick={this.handleValidation}
                                disabled={this.props.isViewing ?? !this.props.articleCatalogueMilestoneForm.formula}
                            >
                                {this.toLocaleLanguage("validate_formula")}
                            </Button>
                            <span className="tooltip-text">{this.toLocaleLanguage("validate_formula")}</span>
                        </div>
                        <span className="tooltip-text">{this.toLocaleLanguage("validate_formula")}</span>
                                </div>
                            </>
                        ) : null
                    }  

                </div>
                <span>
                    {ARTICLE_FORMULA_LABELS.Note}
                </span>

                <NotificationModal
                    show={this.state.showNotif}
                    title={this.state.haveError ? 'Error' : 'Success'}
                    message={this.toLocaleLanguage(this.state.modalMessage)}
                    handleModal={this.handleCloseNotif}
                    customClass={'comment-notification-modal notification-footer modal-text-bold confirmation-blur-background'}
                />

                <ConfirmationNotificationModal
                    show={this.state.showModal}
                    message={MODAL_CUSTOM_MESSAGE.clear_formula}
                    title={"Clear Formula"}
                    handleModal={this.handleConfirmationModal}
                    customClass={'comment-notification-modal modal-text-bold'}
                />

            </div>
        )
    }
}

export default withRouter(connect(
    state => {
        const {
            articleCatalogueMilestone
            , translation
            , form: { forms: { articleCatalogueMilestoneForm: { $form } } } 
        } = state;
        const { articleCatalogueMilestoneForm } = state.form;
        return {
            translation
            , articleCatalogueMilestone
            , articleCatalogueMilestoneForm
            , $form
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, articleCatalogueMilestoneActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        }
    })
)(Formula));